var OCS = OCS || {};
OCS.Advisories = OCS.Advisories || {};
OCS.Advisories.Interfaces = OCS.Advisories.Interfaces || {};
OCS.Advisories.Interfaces.AdvActions = {
    adv_action_strings: {
        "NEW": "New event",
        "CON": "Event continued",
        "EXT": "Event extended (time)",
        "EXA": "Event extended (area)",
        "EXB": "Event extended (both time and area)",
        "UPG": "Event upgraded",
        "CAN": "Event cancelled",
        "EXP": "Event expired",
        "COR": "Correction",
        "ROU": "Routine"
    }
};
/* istanbul ignore next */
try {
    if (typeof (module) !== 'undefined') {
        module.exports = OCS.Advisories.Interfaces.AdvActions.adv_action_strings;
    }
} catch(e) {
    
}
